import { AppContext } from '@invivodf/common/app.context'

export function getLocaleForBrand(brand: AppContext) {
  switch (brand) {
    case AppContext.aladin:
      return {
        lang: 'fr',
        locale: 'fr-FR',
      }

    case AppContext.farmi:
      return {
        lang: 'fr',
        locale: 'fr-FR',
      }

    case AppContext.episens:
      return {
        lang: 'fr',
        locale: 'fr-FR',
      }

    case AppContext.countrymalt:
      return {
        lang: 'en',
        locale: 'en-US',
      }

    case AppContext.jardiland:
      return {
        lang: 'fr',
        locale: 'fr-FR',
      }

    case AppContext.gammvert:
      return {
        lang: 'fr',
        locale: 'fr-FR',
      }
    default:
      return {
        lang: 'fr',
        locale: 'fr-FR',
      }
  }
}
